import { grey400, grey500 } from "styles";

export const styles = {
  emailContainer: {
    backgroundColor: grey500,
    borderRadius: "8px",
    padding: "16px",
  },
  divider: {
    borderBottom: `1px solid ${grey400}`,
    mt: 3,
    mb: 3,
  },
};
